<template>
  <div class="mt-8 flex">
    <div class="w-1/3">
      <h2>Date Picker</h2>
    </div>
    <div class="w-2/3">
      <m-form>
        <m-datepicker v-model="finYear" />
      </m-form>
      <pre>{{ finYear }}</pre>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { ItemType } from '@/app/utils/constants/ItemType';
import { getDefaultItem } from '@/app/utils/toolkit/defaultItems';
import { toolkitMixin } from '@/app/mixins/toolkit/item';

export default {
  name: 'date-picker',
  mixins: [toolkitMixin],
  computed: {
    finYear: {
      get() {
        return this.getItem?.finYear || '';
      },
      set(value) {
        if (moment.isDate(value)) {
          const ISOString = value.toISOString();
          this.setItem({ finYear: ISOString });
        } else {
          this.setItem({ finYear: '' });
        }
      },
    },
  },
  mounted() {
    this.$store.dispatch('fund/updateOwner');
    this.$store.dispatch('toolkit/loadItem', {
      data: getDefaultItem(ItemType.PENSION_PAYMENT_INSTRUCTION),
    });
    this.$store.dispatch(
      'toolkit/updateItemType',
      ItemType.PENSION_PAYMENT_INSTRUCTION,
    );
  },
};
</script>
